class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.bundleStamp = this.dataset.bundleStamp;
    this.addEventListener('click', async (event) => {
      event.preventDefault();
      const cartItems =
        this.closest('cart-drawer-items') ||
        this.closest('cart-items');

      this.bundleStamp && await removeBundleProperties(this.bundleStamp);
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

/**
 * Cart remove set
 */
class CartRemoveSet extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('click', async (event) => {
      event.preventDefault();
      const cartItems =
        this.closest('cart-drawer-items') ||
        this.closest('cart-items');

      const url = this.querySelector('a').getAttribute('href');

      const body = JSON.stringify({
        sections: cartItems.getSectionsToRender().map(
          section => section.section
        ),
        sections_url: window.location.pathname
      });

      fetch(
        url, {
          ...fetchConfig(),
          ...{ body }
        })
        .then((response) => response.text())
        .then((state) => {
          const parsedState = JSON.parse(state);

          cartItems.getSectionsToRender().forEach(section => {
            const elementToReplace = document.querySelector(section.id);

            elementToReplace.innerHTML = cartItems.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          });
        });
    });
  }
}
customElements.define('cart-remove-set', CartRemoveSet);
class CartItems extends HTMLElement {
  constructor() {
    super();
    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0
    );
    this.debouncedOnChange = debounce(event => {
      this.onChange(event);
    }, 300);
    this.addEventListener(
      'change',
      this.debouncedOnChange.bind(this)
    );
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute('name')
    );
  }

  getSectionsToRender() {
    return [
      {
        id: `#shopify-section-${
          document.getElementById('main-cart-items').dataset.id
        }`,
        section:
          document.getElementById('main-cart-items').dataset.id,
        selector: `#shopify-section-${
          document.getElementById('main-cart-items').dataset.id
        }`
      },
      {
        id: '#cart-counter',
        section: 'cart-counter',
        selector: '#shopify-section-cart-counter'
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map(
        section => section.section
      ),
      sections_url: window.location.pathname
    });

    return fetch(`${routes.cart_change_url}`, {
      ...fetchConfig(),
      ...{ body }
    })
      .then(response => response.text())
      .then(state => {
        const parsedState = JSON.parse(state);

        this.getSectionsToRender().forEach(section => {
          const elementToReplace = document.querySelector(section.id);

          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem = document.getElementById(`CartItem-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`))
          lineItem.querySelector(`[name="${name}"]`).focus();

          document.body.classList.add('no-scroll');
      });
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      document.querySelectorAll(`[data-line-item-error][data-line="${line}"]`).forEach(error => {
        error.innerHTML =
          window.cartStrings.quantityError.replace(
            '[quantity]',
            document.querySelector(`[id*="ProductQuantity-${line}"]`).value
          );
      });
    }

    this.currentItemCount = itemCount;
  }
}

customElements.define('cart-items', CartItems);
